import { ModuleConfig } from '../../modules/utility/module.js';

var defaultOptions = {
  defaultFieldClearerAs: null
};
var config = new ModuleConfig(defaultOptions);
/**
 * Gets current configuration options for form components
 * @returns {object} Form component options
 */

var getFormComponentOptions = function getFormComponentOptions() {
  return config.getAll();
};
/**
 * Configures options for form components
 * @param {object} options Options to set
 * @param {function|object} options.defaultFieldClearerAs The default component for the FieldClearer 'as' prop
 */


var setFormComponentOptions = function setFormComponentOptions(options) {
  config.setAll(options);
};

export { getFormComponentOptions, setFormComponentOptions };
